import z from 'zod'
import {
  nullSafeOptionalBoolean,
  nullSafeOptionalFirestoreTimestamp,
} from '../shared/schema'

export const schema = z.object({
  endedAt: nullSafeOptionalFirestoreTimestamp(),
  roomId: z.string(),
  startedAt: nullSafeOptionalFirestoreTimestamp(),
  success: nullSafeOptionalBoolean(),
})

export const empty = Object.freeze(
  schema.parse({
    endedAt: null,
    success: false,
    roomId: '',
    startedAt: null,
  })
)

export type FirestoreRoomStateAI = z.infer<typeof schema>
